import React from 'react';
import Heading from 'components/Heading';
import Image from 'components/Image';
import List from 'components/List';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import StudentsView from './StudentsView';
import NoStudentsView from './NoStudentsView';
import Row from 'components/Row';
import Text from 'components/Text';

import OverviewImage from 'assets/images/coaching/overview_illustration.svg';

import { CoachingStudentsAndProduct_coaching_studentFamilyMembers as Student } from '../../queries/__generated__/CoachingStudentsAndProduct';

type Props = {
  isLoading: boolean;
  students: Student[];
  selectedChildName: null | string;
  onChildSelection: (e: React.FormEvent<HTMLInputElement>) => void;
};

export default class CoachingDescription extends React.Component<Props> {
  renderStudents() {
    if (this.props.students.length === 0) {
      return <NoStudentsView />;
    }
    return (
      <StudentsView
        students={this.props.students}
        selectedChildName={this.props.selectedChildName}
        onChildSelection={this.props.onChildSelection}
      />
    );
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Image src={OverviewImage} width="100%" roundedCorners />
        </Row>
        <Row>
          <Heading level="2">Your free trial</Heading>
          <Text color="thunder" size="medium">
            Your 7-day trial will include one free 40-minute session with a Remind coach. At the end
            of the trial, you’ll be charged $40/week for a Remind Coaching plan. You can cancel or
            skip at any time.{' '}
            <Link href={LinkConstants.COACHING_HELP} target="_blank">
              <Text weight="semibold">Learn more</Text>
            </Link>
          </Text>
        </Row>
        <Row>
          <Heading level="2">Your Remind Coaching plan</Heading>
          <List delimiter="bullet" size="medium" markerPosition="inside">
            <Text color="thunder" size="medium">
              1-on-1 tutoring for middle and high school math subjects. Available Monday through
              Thursday, 4-10 p.m. Pacific.
            </Text>
            <Text color="thunder" size="medium">
              One 40-minute video chat session per week (with the option to modify as needed)
            </Text>
            <Text color="thunder" size="medium">
              Unlimited messaging during coaching hours
            </Text>
          </List>
        </Row>
        <Row size="xlarge">
          <Row>
            <Heading level="2">Select Students</Heading>
            <Text color="thunder" size="medium">
              Students must have a Remind account to use Remind Coaching.
            </Text>
          </Row>
          <Row size="small">
            <Heading level="3" divided>
              Your children on Remind
            </Heading>
          </Row>
          {this.renderStudents()}
        </Row>
      </React.Fragment>
    );
  }
}
